import { IAppTheme } from 'common/theme';

/**
 * If iOS, do not set a backdropFilter style. Otherwise, return styles for backdrop-filter.
 *
 * Firefox claims to support backdrop-filter, but it doesn't render it correctly,
 * especially when you have an overlap (such as for the sticky dialog footer).
 * Use this function to override styles for Firefox in particular, using a background
 * color fallback to achieve a similar effect.
 * @param theme
 * @param blur {string} - The blur value to use for the backdrop-filter. '60px' by default.
 * @param isIOS
 */
export const getBackdropFilterStyles = (theme: IAppTheme, blur?: string, isIOS?: boolean) => {
  // Context: https://microsoft.visualstudio.com/OS/_workitems/edit/55493928
  if (isIOS) {
    return {
      backdropFilter: 'none !important',
    };
  }

  return {
    // Firefox only
    '@supports (-moz-appearance:none)': {
      backgroundColor: theme.appColors?.white90ToAnchor30tr90,
    },
    // Other browsers
    '@supports not (-moz-appearance:none)': {
      backdropFilter: `blur(${blur ?? '60px'})`,
    },
  };
};
